module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "import-notifications",
      "aria-hidden": "false",
      "aria-labelledby": "exampleGrid",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('automation.index.import_notifications_title')) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#import-notifications')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row-mt-15"
  }, [_c('div', {
    staticClass: "col-7 text-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/SuperHote_icons/warning-2.svg",
      "alt": "",
      "width": "40"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mt-15 notification-desc"
  }, [_vm._v(_vm._s(_vm.$t('automation.index.import_notifications_desc')))])])])]), _vm._v(" "), _c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer justify-content-center"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": _vm.smallLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#import-notifications')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('button.cancel')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "upload"
  }, [_c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "submit",
      "disabled": _vm.smallLoading
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.yes_import')) + "\n          ")]), _vm._v(" "), (!_vm.smallLoading) ? _c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('input', {
    staticClass: "import-notifications",
    attrs: {
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.importNotifications
    }
  })]) : _vm._e()])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30b4c249"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/automation/modals/importNotificationsModal.vue
// module id = 1360
// module chunks = 0